import React from "react";
import { IssuePortal } from "@byscott-io/issuesbyscott_client";
import { useAuth } from '@byscott-io/corebyscott';

export default function SupportPage() {
  const { user, currentContainer } = useAuth();

  if (!currentContainer) {
    return (
      <div className="text-center py-8 text-gray-500">
        Loading...
      </div>
    );
  }

  return (
    <>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Support</h1>
        <p className="mt-1 text-sm text-gray-500">
          Report issues or request features for LifeSkillsPath
        </p>
      </div>

      <IssuePortal
        apiUrl={window.ENV?.ISSUESBYSCOTT_API_URL || "http://localhost:5003/api"}
        apiKey={window.ENV?.ISSUESBYSCOTT_API_KEY || ""}
        user={{
          email: user.email,
          external_id: currentContainer.id.toString(),
          name: currentContainer.name,
          external_user_id: user.id.toString(),
          external_user_name: user.full_name,
        }}
      />
    </>
  );
}
